import { useTranslation } from 'react-i18next';

import { ToggleButton } from '@/components/ui/custom/ToggleButton';
import { AnalyticsOverview } from '@/modules/analytics/components/AnalyticsOverview/AnalyticsOverview';
import { OverviewGlobalExport } from '@/modules/analytics/components/AnalyticsOverview/OverviewGlobalExport';
import { AccountAnalyticsFilters } from '@/modules/analytics/components/filters/AccountAnalyticsFilters/AccountAnalyticsFilters';
import { OVERVIEW_ALLOWED_FILTERS } from '@/modules/analytics/constants';
import { useTrackedComparison } from '@/modules/analytics/hooks/useComparisonMode';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';

const OverviewReportContent = () => {
  const { t } = useTranslation();
  const { isComparing, toggleComparison } = useTrackedComparison(PageName.ANALYTICS_OVERVIEW);

  return (
    <div className="mx-auto max-w-6xl">
      <AccountAnalyticsFilters
        page={PageName.ANALYTICS_OVERVIEW}
        allowedFilters={OVERVIEW_ALLOWED_FILTERS}
        rightActions={
          <ToggleButton pressed={isComparing} onClick={toggleComparison}>
            {t('analytics.compare_prev')}
          </ToggleButton>
        }
        exportActions={<OverviewGlobalExport />}
      />
      <AnalyticsOverview />
    </div>
  );
};

export const OverviewReport = () => {
  useSegments(PageName.ANALYTICS_OVERVIEW);

  return <OverviewReportContent />;
};
